module.exports = __webpack_public_path__ + "static/media/rewind.182f13df.svg";